module.exports = __webpack_public_path__ + "img/scalp_tile.0c765712.jpg";